import { TbLink } from '@website-builder/model/domain/link/tb-link';
import { TableCellItemType } from '@website-builder/widgets/table/model/table-cell-item-type.type';
import { makeEntityId } from '@website-builder/util/make-widget-id.utility';
import { EntityIdPrefix } from '@website-builder/model/domain/entity-id-prefix.enum';
import { ImagePreviewContent } from '@website-builder/media/image-preview/models/image-preview-content.interface';

export class TableCellItem {
  id = makeEntityId(EntityIdPrefix.WIDGET_ELEMENT);
  type: TableCellItemType;
  value: string;
  link: TbLink;
  srcPreview?: ImagePreviewContent;

  constructor(type?: TableCellItemType, value?: string) {
    this.type = type || 'text';
    this.value = value || 'Empty cell';

    if (type === 'button') {
      this.link = new TbLink();
    }
  }

  static normalizeInPlace(item: TableCellItem): TableCellItem {
    const pureItem = new TableCellItem();

    item.type = item.type ?? pureItem.type;
    item.value = item.value ?? pureItem.value;
    item.srcPreview = item.srcPreview ?? pureItem.srcPreview;

    if (item.type === 'button') {
      item.link = TbLink.normalizeInPlace(item.link ?? new TbLink());
    }

    return item;
  }
}
